import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import Investment from 'src/entities/Investment';
import ValidatorService from 'src/services/validation/Validation.service';

export interface CreateInvestmentAttempt extends Action {
  type: Types.CREATE_INVESTMENT_ATTEMPT;
  payload: Investment;
}

export interface CreateInvestmentSuccess extends Action {
  type: Types.CREATE_INVESTMENT_SUCCESS;
  payload: Investment;
}

export interface CreateInvestmentFailure extends Action {
  type: Types.CREATE_INVESTMENT_FAILURE;
  payload: {};
}

export type CreateInvestmentAction = CreateInvestmentAttempt |
  CreateInvestmentSuccess |
  CreateInvestmentFailure;

export interface CreateInvestmentThunk extends
  ThunkAction<Promise<CreateInvestmentAction>, RootState, null> {
}

export const createInvestmentAttempt: ActionCreator<CreateInvestmentAttempt> = (
  investment: Investment
) => (
    {
      type: Types.CREATE_INVESTMENT_ATTEMPT,
      payload: investment,
    }
  );

export const createInvestmentSuccess: ActionCreator<CreateInvestmentSuccess> = (
  investment: Investment
) => (
    {
      type: Types.CREATE_INVESTMENT_SUCCESS,
      payload: investment,
    }
  );

export const createInvestmentFailure: ActionCreator<CreateInvestmentFailure> = (error: {}) => (
  {
    type: Types.CREATE_INVESTMENT_FAILURE,
    payload: error
  }
);

export const createInvestment: ActionCreator<CreateInvestmentThunk> = (
  investment: Investment
): CreateInvestmentThunk => {

  return (dispatch: Dispatch<RootState>): Promise<CreateInvestmentAction> => {
    dispatch(createInvestmentAttempt());

    return ApiClient.investment.create(investment)
      .then((response: AxiosResponse<Investment>): CreateInvestmentSuccess => {

        const successPayload: Investment = response.data;

        return dispatch(createInvestmentSuccess(successPayload));
      }).catch((e: { response: { data: { error: {} } } }): CreateInvestmentFailure => {
        const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

        return dispatch(createInvestmentFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/investment/create/CreateInvestment.actions.tsx